import MyApplicationsPanel from "./MyApplicationsPanel";

export default MyApplicationsPanel;
